// extracted by mini-css-extract-plugin
export default {"AcceptPartnerInviteForm__helpOrErrorMessage":"AcceptPartnerInviteForm__AcceptPartnerInviteForm__helpOrErrorMessage__LMFAX"};